export const NL_LANES = {
  FEDERAL_CONTRACT_OPPORTUNITIES: 'federal-contract-opportunities',
  VENDORS: 'vendors',
  FEDERAL_CONTRACT_AWARDS: 'federal-contract-awards',
  SLED_AWARDS: 'sled-awards',
  SLED_OPPORTUNITIES: 'sled-opportunities',
  SLED_FORECASTS: 'sled-forecasts',
  FEDERAL_AGENTS: 'federal-agents',
  FEDERAL_GRANT_OPPORTUNITIES: 'federal-grant-opportunities',
  FEDERAL_AGENCIES: 'federal-agencies',
  NSN_OPPORTUNITIES: 'nsn-opportunities',
};

export const NL_SEARCH_MODES = {
  FILTERED: 'filtered',
  NATURAL_LANGUAGE: 'natural-language',
  RECOMMENDATIONS: 'recommendations',
};

export const FCO_NL_SUGGESTIONS = [
  'IT staffing contracts in Texas under $5M closing next month',
  '8(a) set-aside construction awards posted this week',
  'Cybersecurity opportunities for small businesses in California',
];

export const VENDORS_NL_SUGGESTIONS = [
  'Woman-owned IT vendors in Texas active in SAM',
  '8(a) certified construction vendors in California',
  'Cybersecurity vendors with NAICS 541512',
];

export const AWARDS_NL_SUGGESTIONS = [
  'Awards to small businesses in California last year',
  'IT contract awards over $1M completing next year',
  'Cybersecurity awards by the Department of Defense',
];

export const SLED_AWARDS_NL_SUGGESTIONS = [
  'State and local awards in California',
  'Awards over $500K in Texas',
  'City and county awards in Florida',
];

export const SLED_OPPORTUNITIES_NL_SUGGESTIONS = [
  'IT opportunities from California transportation agencies',
  'Construction bids in Los Angeles County due next quarter',
  'State agency opportunities posted this month with NAICS 541611',
];

export const SLED_FORECASTS_NL_SUGGESTIONS = [
  'Forecasted IT projects from California transportation agencies',
  'Upcoming construction forecasts in Los Angeles County',
  'Anticipated state agency opportunities expected next quarter',
];

export const FEDERAL_AGENTS_NL_SUGGESTIONS = [
  'Contracting officers for IT services in Texas',
  'Air Force contracting specialists with email',
  'Contracting officers with NAICS 541512',
];

export const FEDERAL_GRANTS_NL_SUGGESTIONS = [
  'Technology grants closing next month',
  'Education and health grants posted this week',
  'Energy grants for nonprofit applicants',
];

export const FEDERAL_AGENCIES_NL_SUGGESTIONS = [
  'Defense logistics agencies in Maryland',
  'Offices under Department of Transportation',
  'Civilian agencies with procurement offices',
];

export const NSN_OPPORTUNITIES_NL_SUGGESTIONS = [
  'Aviation parts closing next week',
  'Hydraulics issued this month',
  'Electrical equipment with buyer code PDPSF',
];
